import React from "react"
import FloatingActionButton from "material-ui/FloatingActionButton"
import ContentAdd from "material-ui/svg-icons/content/add"
import Paper from "material-ui/Paper"
import FlatButton from "material-ui/FlatButton"
import CircularProgress from "material-ui/CircularProgress"
import Dialog from "material-ui/Dialog"
import Table from "material-ui/Table"
import TableRow from "material-ui/Table/TableRow"
import TableRowColumn from "material-ui/Table/TableRowColumn"
import TableBody from "material-ui/Table/TableBody"
import autobind from "class-autobind"
import TableActionBar from "../../components/layout/TableActionBar"
import EquipmentTable from "./EquipmentTable"
import AddEquipmentDialog from "./AddEquipmentDialog"
import strings from "../../localization/strings"
import EquipmentStore from "../../stores/EquipmentStore"
import HierarchySettingsStore from "../../stores/HierarchySettingsStore"
import { browserHistory } from "react-router"
import AuthenticationStore from "../../stores/AuthenticationStore"
import AccountStore from "../../stores/AccountStore"
import * as equipmentActions from "../../actions/EquipmentActions"
import * as permissionHelper from "../../helpers/permissionHelper"
import { IEquipmentDocument } from "../../models"
let searchTimeout
interface IState {
    equipmentList: IEquipmentDocument[]
    page: number
    limit: number
    search: string
    selectedEquipmentList: IEquipmentDocument[]
    loading: boolean
    showAddDialog: boolean
    showTableActionBar: boolean
    showTable: boolean
    showAlertTitle: string
    showDeleteDialog: boolean
}

export default class Equipment extends React.Component<null, IState>  {
    constructor(props) {
        super(props)
        this.state = {
            equipmentList: [],
            page: 0,
            limit: EquipmentStore.getLimit(),
            search: EquipmentStore.getSearch(),
            selectedEquipmentList: [],
            loading: false,
            showAddDialog: false,
            showTableActionBar: true,
            showTable: true,
            showAlertTitle: "",
            showDeleteDialog: false,
        }
        autobind(this)
    }

    componentDidMount() {
        document.title = `${strings.Equipment} | ${strings.Findd_Grandd_Central}`
        EquipmentStore.on("change", this.equipmentChangeEvent)
        HierarchySettingsStore.on("change", this.equipmentChangeEvent)
        this.getEquipmentList()
    }

    componentWillUnmount() {
        EquipmentStore.removeListener("change", this.equipmentChangeEvent)
        HierarchySettingsStore.removeListener("change", this.equipmentChangeEvent)
        equipmentActions.setFilterText()
    }

    equipmentChangeEvent() {
        this.setState({
            equipmentList: EquipmentStore.getEquipmentList(),
            page: EquipmentStore.getPage(),
            search: EquipmentStore.getSearch(),
            limit: EquipmentStore.getLimit(),
            selectedEquipmentList: []
        }, () =>
            this.reloadTable()
        )
    }

    getEquipmentList() {
        this.setState({ loading: true })
        const hierarchyItemId = HierarchySettingsStore.getGlobalLevelItemFilterId()
        equipmentActions.getEquipmentList(hierarchyItemId, this.state.page, this.state.limit, this.state.search,
            () => this.setState({ loading: false })
        )
    }

    onSearch(search) {
        if (searchTimeout) clearTimeout(searchTimeout)
        this.setState({
            search,
            page: 0,
            loading: true,
            equipmentList: [],
            selectedEquipmentList: []
        }, () =>
            searchTimeout = setTimeout(() => {
                this.getEquipmentList()
            }, 880)
        )
    }

    reloadTable() {
        this.setState({ showTable: false }, () =>
            this.setState({ showTable: true })
        )
    }

    onRowClick(equipmentId) {
        const subpage = AccountStore.getTimecardEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.Timecards.ViewTimecards) ? "/timecards" : "/history"
        browserHistory.replace("/equipment-details/" + equipmentId + subpage)
    }

    onTableRowSelected(selectedEquipmentList, reloadTable = true) {
        this.setState({ selectedEquipmentList },
            () => reloadTable && this.reloadTable()
        )
    }

    onPageClick(page) {
        this.setState({ page }, () => {
            this.getEquipmentList()
        })
    }

    onLimitChange(limit) {
        this.setState(
            {
                limit,
                page: 0
            },
            () => {
                this.getEquipmentList()
            }
        )
    }

    showAlert(title) {
        this.setState(
            {
                showAlertTitle: title
            },
            () => {
                setTimeout(() => {
                    this.setState({
                        showAlertTitle: ""
                    })
                }, 2000)
            }
        )
    }

    onDelete() {
        const selectedEquipmentList = this.state.selectedEquipmentList.slice()
        this.setState({ showDeleteDialog: false })
        const promiseArray = []
        selectedEquipmentList.forEach((equipment) => {
            promiseArray.push(this.deleteEquipment(equipment.Id))
        })
        Promise.all(promiseArray).then((value) => {
            const alertTitle = strings.Equipment_deleted_successfully
            this.showAlert(alertTitle)
        })
    }

    deleteEquipment(equipmentId) {
        return new Promise(function (resolve, reject) {
            equipmentActions.deleteEquipment(equipmentId).then((res) => {
                resolve(res)
            })
        })
    }

    render() {
        const deleteTitle = strings.DELETE_EQUIPMENT
        const deleteBody = strings.Confirm_delete_equipment

        return (
            <div className="page-container Users">
                <div className="page-container-parent">
                    {permissionHelper.hasPermission(AuthenticationStore.Permissions.Equipment.AddEquipment) && (
                        <FloatingActionButton className="fixed-add" style={{ top: 83, right: 40, zIndex: 998 }} secondary={true} onTouchTap={() => this.setState({ showAddDialog: true })}>
                            <ContentAdd />
                        </FloatingActionButton>
                    )}
                    <Paper zDepth={1} className="page-paper">
                        {this.state.showTableActionBar && (
                            <TableActionBar
                                rowSelectionCount={this.state.selectedEquipmentList.length}
                                singleSelectedMessage={strings.Equipment_Selected}
                                multipleSelectedMessage={strings.x_Equipment_Selected}
                                title={strings.Equipment}
                                onSearch={this.onSearch}
                                reloadTable={this.getEquipmentList}
                                searchText={this.state.search}
                                onDeleteClick={() => this.setState({ showDeleteDialog: true })}
                                readonly={!permissionHelper.hasPermission(AuthenticationStore.Permissions.Equipment.DeleteEquipment)}
                            />
                        )}
                        <div style={{ padding: 20 }}>
                            {this.state.loading ? (
                                <div className="spinner">
                                    {" "}
                                    <CircularProgress />{" "}
                                </div>
                            ) : (
                                    <div>
                                        {(!this.state.equipmentList.length && (
                                            <Table>
                                                <TableBody displayRowCheckbox={false}>
                                                    <TableRow>
                                                        <TableRowColumn>
                                                            <div>
                                                                <h2
                                                                    style={{
                                                                        textAlign: "center",
                                                                        marginTop: 25
                                                                    }}
                                                                >
                                                                    {strings.No_equipment_found}
                                                                </h2>
                                                            </div>
                                                        </TableRowColumn>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        )) ||
                                            (this.state.showTable && (
                                                <EquipmentTable
                                                    equipmentList={this.state.equipmentList}
                                                    page={this.state.page}
                                                    limit={this.state.limit}
                                                    total={EquipmentStore.getTotalEquipmentCount()}
                                                    limitOptions={EquipmentStore.getLimitOption()}
                                                    rowSelected={this.onTableRowSelected}
                                                    onPageClick={this.onPageClick}
                                                    onLimitChange={this.onLimitChange}
                                                    onRowClick={this.onRowClick}
                                                    readonly={!permissionHelper.hasPermission(AuthenticationStore.Permissions.Equipment.DeleteEquipment)}
                                                    selectedEquipmentList={this.state.selectedEquipmentList}
                                                />
                                            ))}
                                    </div>
                                )}
                        </div>
                    </Paper>
                    {this.state.showAddDialog &&
                        <AddEquipmentDialog
                            onClose={() => this.setState({ showAddDialog: false })}
                        />
                    }
                    {this.state.showDeleteDialog && (
                        <Dialog
                            title={deleteTitle}
                            actions={[<FlatButton label={strings.Delete} primary onTouchTap={this.onDelete} />, <FlatButton label={strings.Cancel} secondary onTouchTap={() => this.setState({ showDeleteDialog: false })} />]}
                            modal
                            open={this.state.showDeleteDialog}
                        >
                            {deleteBody}
                        </Dialog>
                    )}
                    {this.state.showAlertTitle && <Dialog open>{this.state.showAlertTitle}</Dialog>}
                </div>
            </div>
        )
    }
}
